import React, { useEffect, useRef, useState, memo } from "react";
import Menubar from "../../components/Menu";
import BottomNavigation from "../../components/Navigations/BottomNavigation";

type Props = {
  children: any,
  pageID: String,
  displayBottomNav: boolean,
  activeNav: String,
};

const MainLayout = ({
  children,
  pageID,
  displayBottomNav,
  activeNav,
}: Props) => {
  const ref = useRef();

  useEffect(() => {}, []);

  
  return (
    <>
      <Menubar />
      <main className={pageID} id={pageID}>
        {children}
      </main>
      {displayBottomNav && <BottomNavigation activeNav={activeNav} />}
    </>
  );
};

MainLayout.defaultProps = {
  displayBottomNav: true,
};

export default memo(MainLayout);
